<template>
    <base-modal :title="$t('expiredInventory.businessOrders.title')"
                :config="{ focusFirst: false, closeToClick: false }"
                :show-close="false"
    >
        <template slot="titleTooltip">
            <button-tooltip v-tooltip.bottom="{
                content: $t('expiredInventory.businessOrders.tooltip'),
                delay: { show: 500, hide: 300 },
            }"
            />
        </template>
        <expired-lot-business-order-create-form ref="form"
                                                :is-smart-freight-selected="isSmartFreightSelected"
                                                :business-order="modalData.businessOrder"
                                                :expired-items="modalData.expiredItems"
                                                :warehouses="modalData.warehouses"
                                                @save="save"
                                                @cancel="$emit('close')"
        />
    </base-modal>
</template>
<script>
import { $t } from '@/translations';
import businessOrdersApi from '@/services/resources/businessOrdersApi';
import BaseModal from '@/components/modal/BaseModal';
import ExpiredLotBusinessOrderCreateForm from '@/views/business-orders/ExpiredLotBusinessOrderCreateForm';
import ButtonTooltip from '@/components/buttons/ButtonTooltip';

export default {
    name: 'ExpiredLotBusinessOrderCreate',
    components: {
        BaseModal,
        ExpiredLotBusinessOrderCreateForm,
        ButtonTooltip,
    },
    props: {
        isSmartFreightSelected: {
            type: Boolean,
            default: false,
        },
        expiredItems: {
            type: Array,
            required: true,
            default: () => [],
        },
        warehouses: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
    data() {
        return {
            modalData: {
                businessOrder: null,
                expiredItems: this.expiredItems,
                warehouses: this.warehouses,
                isSmartFreightSelected: null,
            },
        };
    },
    methods: {
        async save(data) {
            const form = this.$refs.form.getFormControl();
            const businessOrder = await form.handle(() => businessOrdersApi.create(data));
            if (businessOrder) {
                this.$toast.success($t('businessOrders.toasts.orderCreated'));
                this.$parent.$emit('save', { sku: businessOrder.sku, businessOrder });
                this.$emit('save', { sku: businessOrder.sku, businessOrder });
                this.$emit('close');
            }
        },
        getBusinessOrder() {
            const itemList = this.expiredItems.map(item => ({
                sku: item.itemId,
                quantity: item.quantity,
                availableQty: item.quantity,
                isBackOrdered: false,
            }));

            return {
                items: itemList,
            };
        },
    },
};
</script>
